export const TOKEN_SECRET = "$xd8%M3d_mE-sv&WYNA^";

export const IMG_BASE_URL = "https://api-ayandeh.dadekavweb.ir/";

export const PAGINATION_LIMIT = 10;

export const ADMIN_ACCESS = [
  { label: "مدیریت سفارش های کل", value: "get_orders" },
  { label: "مدیریت سفارش های روز", value: "get_todays_orders" },
  { label: "مدیریت کاربران", value: "manage_users" },
  { label: "مدیریت محصولات", value: "manage_products" },
  { label: "تنظیم زمان سفارش", value: "manage_order_time_limit" },
  { label: "آمار محصولات", value: "get_stats" },
  { label: "مدیریت ارسال پیام ها", value: "send_notifications" },
  { label: "مدیریت تخفیف ها", value: "manage_discounts" },
  {
    label: "مدیریت سایت(اسلاید-محصولات نمایشی - اخبار و... )",
    value: "manage_settings",
  },
];

export const ADMIN_ROUTES = {
  get_orders: "/orders",
  get_todays_orders: "/",
  manage_users: "/users",
  manage_products: "/products",
  manage_order_time_limit: "/time-limit",
  get_stats: "/product-stats",
  send_notifications: "/notification",
  manage_discounts: "/discount",
  manage_settings: "manage_settings",
};
